
import React, { useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
 
// Function to fetch data from API
const fetchTransactionData = async (params) => {
    console.log("Fetching with params:", JSON.stringify(params));

    const response = await fetch(`${process.env.REACT_APP_URL_FPS}/fps/dateWiseTransDetails`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    });
    if (!response.ok) {
        throw new Error('Failed to fetch transaction data');
    }

    const data = await response.json();
 
    return data;
};

const DetailedTransaction = ({ districtName, month, year, fps_id }) => {
    const [dateWiseList, setDateWiseList] = useState([]);
    const [commodityList, setCommodityList] = useState([]); // State for commodity list
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(null);
    const [renderContent, setRenderContent] = useState(null);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [searchQuery, setSearchQuery] = useState('');
    const detailsRef = useRef(null);

    useEffect(() => {
        const getData = async () => {
            setLoading(true);
            const params = {
                dist_code: districtName,
                month: month,
                year: year,
                fps_id: fps_id
            };

            try {
                const response_data = await fetchTransactionData(params);
                setTabHeading(response_data.heading);
                if (response_data && response_data.dateWiseList) {
                    setDateWiseList(response_data.dateWiseList);

                    // Dynamically extract commodities from the response (assuming commoditylist exists)
                    const commodities = response_data.dateWiseList.reduce((acc, item) => {
                        item.commoditylist?.forEach(commodity => {
                            if (!acc.some(existing => existing.comm_short === commodity.comm_short)) {
                                acc.push(commodity);
                            }
                        });
                        return acc;
                    }, []);

                    setCommodityList(commodities); // Set dynamic commodity list
                } else {
                    setDateWiseList([]);
                }
            } catch (error) {
                console.error(error);
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, [districtName, month, year, fps_id]);

    useEffect(() => {
        if (!loading && !error && dateWiseList.length > 0 && detailsRef.current) {
            detailsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [loading, error, dateWiseList]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (value) => {
        setRowsPerPage(value === 'all' ? dateWiseList.length : parseInt(value, 10));
        setPage(0);
    };

    const filteredData = dateWiseList.filter(item =>
        item.avilcards.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.date.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const paginatedData = rowsPerPage === 'all'
        ? filteredData
        : filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    // Initialize totals array for each commodity and total for available cards
    const commodityTotals = Array(commodityList.length).fill(0);
    let totalAvailableCards = 0;

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'start' }}>
                   
                <Box sx={{ display: 'flex' }}>
                    <CircularProgress />
                </Box>
            </div>
        );
    }

    if (error) {
        return <div className="mainhead" align="center">Internal Error</div>;
    }

    if (dateWiseList.length === 0) {
        return <div className="mainhead" align="center">No data found</div>;
    }

    return (
        <>
            <br></br>
            <table align="center" width="80%" border={1}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={3+commodityList.length}>{tabHeading}</th>
                    </tr>
                    <tr className="tableheader">
                        <th rowSpan={2}>Sl.No</th>
                        <th rowSpan={2}>Date</th>
                        <th rowSpan={2}>Available <br/> Cards</th>
                        <th colSpan={commodityList.length}>Issue Qty</th>
                    </tr>
                    <tr className="tableheader">
                        {commodityList.map((item, index) => (
                            <th key={index}>{item.comm_short}<br></br>(Kgs)</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {paginatedData.map((item, index) => {
                        totalAvailableCards += parseInt(item.avilcards, 10) || 0;

                        return (
                            <tr key={`${item.dist_code}-${index}`}>
                                <td style={{ textAlign: 'center' }}>
                                    {rowsPerPage === 'all' ? index + 1 : index + 1 + page * rowsPerPage}
                                </td>
                                <td style={{ textAlign: 'left' }}>
                                    {item.date}
                                </td>
                                <td style={{ textAlign: 'right' }}>
                                    {item.avilcards}
                                </td>
                                {commodityList.map((commodity, i) => {
                                    const quantity = item.commoditylist?.find(c => c.comm_short === commodity.comm_short)?.sale_qty || 0;
                                    commodityTotals[i] += parseFloat(quantity, 10);
                                    return (
                                        <td key={i} style={{ textAlign: 'right' }}>
                                            {quantity}
                                </td>
                                    );
                                })}
                            </tr>
                        );
                    })}
                    <tr className="tableheader">
                        <td colSpan={2} style={{ textAlign: 'center' }}>Total</td>
                        <td  >{totalAvailableCards}</td>
                        {commodityTotals.map((total, i) => (
                            <td key={i} style={{ textAlign: 'center' }}>{total.toFixed(2)}</td>
                        ))}
                    </tr>
                </tbody>
            </table>
            <br></br>
            <br></br>
            <div ref={detailsRef}>{renderContent}</div>
        </>
    );
};

export default DetailedTransaction;


